import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState } from 'react';
import { Alert, Button, Divider, Flex, message, Modal, Typography } from 'antd';
import { Link } from 'react-router-dom';
import TextArea from 'antd/es/input/TextArea';
import commonService from '../../services/CommonService';
import mdmService from '../../services/MDMService';
import { useSelector } from 'react-redux';
import { UserActivity } from "../../config/BVConstants";
const RegLibShareDialog = ({ title, data, open, handleCloseModal }) => {
    const [confirmLoading, setConfirmLoading] = useState(false);
    const [emailIds, setEmailIds] = useState("");
    const [messageApi, contextHolder] = message.useMessage();
    const applicationData = useSelector((state) => state.applicationData);
    const handleOk = () => {
        var _a, _b, _c, _d, _e, _f;
        if (!isValidEmailIds()) {
            messageApi.open({
                key: 'invalid_email_str',
                type: 'error',
                content: 'Please enter valid email Id(s).',
                duration: 3,
            });
        }
        else {
            setConfirmLoading(true);
            const objRegLib = {
                strClientLoggedInUser: (_b = (_a = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _a === void 0 ? void 0 : _a.userLoginDetails) === null || _b === void 0 ? void 0 : _b.strUserEmailId,
                intCompanyID: (_d = (_c = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _c === void 0 ? void 0 : _c.userLoginDetails) === null || _d === void 0 ? void 0 : _d.intCompanyID,
                strTitle: data === null || data === void 0 ? void 0 : data.strTitle,
                objLuCountry: data === null || data === void 0 ? void 0 : data.objLuCountry,
                objLuClassification: data === null || data === void 0 ? void 0 : data.objLuClassification,
                strEmailAdrrsLstToShareRegLib: emailIds,
                strShareUrl: window.location.origin + `/regulatory-library-details/${(data === null || data === void 0 ? void 0 : data.strRegLibId) ? btoa(data === null || data === void 0 ? void 0 : data.strRegLibId) : null}`
            };
            mdmService.shareRegLibInfo(objRegLib);
            commonService
                .logUserActivity((_f = (_e = applicationData === null || applicationData === void 0 ? void 0 : applicationData.loggedInClient) === null || _e === void 0 ? void 0 : _e.userLoginDetails) === null || _f === void 0 ? void 0 : _f.strUserEmailId, UserActivity.CP__RegLibDashboard_Share);
            messageApi.open({
                key: 'shared_successfully',
                type: 'success',
                content: 'Regulatory Library URL shared successfully.',
                duration: 3,
            });
            handleCloseModal();
            setConfirmLoading(false);
        }
    };
    const handleCancel = () => {
        handleCloseModal();
    };
    const isValidEmailIds = () => {
        const regex = /[,;]/;
        const emailIdsArray = emailIds === null || emailIds === void 0 ? void 0 : emailIds.split(regex);
        for (const emailId of emailIdsArray) {
            if (!/^[^@]+@[^@]+$/.test(emailId)) {
                return false;
            }
        }
        return true;
    };
    return (_jsxs(_Fragment, { children: [_jsxs(Modal, { title: title, open: open, onOk: handleOk, confirmLoading: confirmLoading, onCancel: handleCancel, footer: [
                    _jsx(Button, { onClick: handleCancel, children: "Cancel" }, "back"),
                    _jsx(Button, { type: "primary", onClick: handleOk, children: "Share" }, "submit")
                ], children: [_jsx(Divider, { style: { margin: '10px 0px' } }), _jsxs(Flex, { vertical: true, gap: 5, children: [_jsx(Link, { to: `/regulatory-library-details/${(data === null || data === void 0 ? void 0 : data.strRegLibId) ? btoa(data === null || data === void 0 ? void 0 : data.strRegLibId) : null}`, children: data === null || data === void 0 ? void 0 : data.strTitle }), _jsx(Typography.Text, { children: "Please enter email address:" }), _jsx(TextArea, { rows: 4, value: emailIds, onChange: (e) => {
                                    setEmailIds(e.target.value);
                                } }), _jsx(Alert, { message: "*Please Separate Email ids with a semicolon(;) or comma(,)", type: "info" })] })] }), contextHolder] }));
};
export default RegLibShareDialog;
